
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404oAfSjI3qEkW_45dudVrYQ2v0jPYd_t_4C1r2DFQYLws1AMeta } from "/var/www/tiodomin.com/pages/404.vue?macro=true";
import { default as infoEhggNO_UlNEsAVdmXe2T7lxdo7_W8EcTiMG9JrvYbB0Meta } from "/var/www/tiodomin.com/pages/info.vue?macro=true";
import { default as indexGde6TRCslKgp7HMBmmFK3NvQc12F2pWCDwEB7gUOvxgMeta } from "/var/www/tiodomin.com/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93ENpp3rGFw9lUc6LtXxIHk6SykoInCoOFH4R7JG_koQ4Meta } from "/var/www/tiodomin.com/pages/[...slug].vue?macro=true";
import { default as Loginfn93DXtkQsd2YoTvrlg_45wzRqKXAaIe5XY1jjsoNzBVoMeta } from "/var/www/tiodomin.com/pages/Auth/Login.vue?macro=true";
import { default as indexK_45XKSV6ZJYzOdRk2jiYtO1I3K3K9ynl928JXXoGC38QMeta } from "/var/www/tiodomin.com/pages/blog/index.vue?macro=true";
import { default as indexvTrhqHe5Mt88gBU9zCZK2oC5jsTQQHdjeuzEKxce0L8Meta } from "/var/www/tiodomin.com/pages/Cart/index.vue?macro=true";
import { default as _91blog_93NxnefInFDFb73jCIDAdpSFbYyx_ZcTQi6o4bKVeqJuEMeta } from "/var/www/tiodomin.com/pages/blog/[blog].vue?macro=true";
import { default as indexUqAkg1fYLS8XScs07cq01l5KcCDzxCc1dCQzQb8yotQMeta } from "/var/www/tiodomin.com/pages/store/index.vue?macro=true";
import { default as indexzRt19rEySWiMy1rDMYjLnJT7ZmD8KzdE_plWkXNbizoMeta } from "/var/www/tiodomin.com/pages/Offers/index.vue?macro=true";
import { default as Registers158W77S0coLwTB40h7xiNoZvpqdD1X98zOfcurFTggMeta } from "/var/www/tiodomin.com/pages/Auth/Register.vue?macro=true";
import { default as indexT7HSezDPiJ8RjsmZEuPKbK2KaMRWh0KT67b9hx7MYp4Meta } from "/var/www/tiodomin.com/pages/Profile/index.vue?macro=true";
import { default as Indexd156X_KU9AOndACIVU_XBZ_45Ikzj4PsBcamfZ1SvaQV4Meta } from "/var/www/tiodomin.com/pages/Products/Index.vue?macro=true";
import { default as CreateVXUQjDx17C4WU1CdouIPRVDXNFV6WI23zxfxqThAByUMeta } from "/var/www/tiodomin.com/pages/Products/Create.vue?macro=true";
import { default as _91id_93wcYhWgD4ChJQGMpiwQTsoCdpS90MUZzVAH_Vm9RmLBcMeta } from "/var/www/tiodomin.com/pages/admin/roles/[id].vue?macro=true";
import { default as _91id_936RGwGO3QU64w_619DpCFxEKegyyHC7_457f2y8jh1LS30Meta } from "/var/www/tiodomin.com/pages/admin/users/[id].vue?macro=true";
import { default as VerifyEmail0UsRGLGBw_45nwSquhGpCN8OEfjt9Cl91SPG7oJopw0fcMeta } from "/var/www/tiodomin.com/pages/Auth/VerifyEmail.vue?macro=true";
import { default as indexd2fVo3L4bHASjki7YkIULhlBzFWK7GgyBPcAMTY6kWUMeta } from "/var/www/tiodomin.com/pages/Contact-Us/index.vue?macro=true";
import { default as _91id_93f1T382IGnwYAEosvcfjv87F0oBpYLcBAIfNXUrMfem4Meta } from "/var/www/tiodomin.com/pages/admin/brands/[id].vue?macro=true";
import { default as _91id_93kntZo2JtxOn4HbI9_45WWjBoNvvoo_45hV0bdy_F6UvC6w4Meta } from "/var/www/tiodomin.com/pages/admin/combos/[id].vue?macro=true";
import { default as _91id_933ytNar1YYFS9k5QQzIkMJ7oixxDiX_451ptJKFsiQWyyQMeta } from "/var/www/tiodomin.com/pages/admin/offers/[id].vue?macro=true";
import { default as indexOrqGr5ejLYq_45aS_45hy9O6NCc7ng1TDa6ZWwPvpU_45gHUwMeta } from "/var/www/tiodomin.com/pages/admin/roles/index.vue?macro=true";
import { default as indexFs2H_bDMHBVxRB4AcKSKy_45q8tNkDUYhFcWohVLv8CiwMeta } from "/var/www/tiodomin.com/pages/admin/users/index.vue?macro=true";
import { default as _91id_93UVva_45JoDbHLbOkYuJF_RJcf0OuIxtz2AcaKvaHIbT6oMeta } from "/var/www/tiodomin.com/pages/admin/banners/[id].vue?macro=true";
import { default as indexupZicUWiaEW5W_45uToxxt_45rN5R7uoXQUVMXWmFxsu1LQMeta } from "/var/www/tiodomin.com/pages/admin/brands/index.vue?macro=true";
import { default as indexx3Rq9t0jaF4IvfEr8em8ijRwQkEYZho4eSaupiuuDpAMeta } from "/var/www/tiodomin.com/pages/admin/combos/index.vue?macro=true";
import { default as indexF0XM7UzLffxHud0eXs_45vdo5jfD8SALwgHLumO1h6wgcMeta } from "/var/www/tiodomin.com/pages/admin/offers/index.vue?macro=true";
import { default as indexFB6K56NAbfy10k9uWxBOxQXeFOyHNv44WRmFXroU5kkMeta } from "/var/www/tiodomin.com/pages/admin/orders/index.vue?macro=true";
import { default as CreatepmHxsO_45lkUqbPTjnfjyXklX0mvmGN2DAl4jhdcgdQBIMeta } from "/var/www/tiodomin.com/pages/admin/roles/Create.vue?macro=true";
import { default as createBttDJ0Q_45BUPIyu40N4Q9py8A0GWpr0pd4_CzugzbbbEMeta } from "/var/www/tiodomin.com/pages/admin/users/create.vue?macro=true";
import { default as _91token_93sCba_45cX_ZZnV9fpk9kSWFMOYNHBOgHyviQYWlGci2PIMeta } from "/var/www/tiodomin.com/pages/Auth/ResetPassword/[token].vue?macro=true";
import { default as ResetPasswordvV8JgYmHc3WvIapZKBrjO0MOBrwk2lSq8w0mhn94_45dAMeta } from "/var/www/tiodomin.com/pages/Auth/ResetPassword.vue?macro=true";
import { default as Indexx4QUaC6qVE_454fJGjQ85DPtph_45UNF6wyoQwgFlj9k6JYMeta } from "/var/www/tiodomin.com/pages/Distribution/Index.vue?macro=true";
import { default as EditxWRsVm_454onBwOa7ct3h__45FF8lZdHyMR03OlaBUva3usMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Edit.vue?macro=true";
import { default as _91product_9339ZFB_45JUzLOjAzytQP6JxHVQZBBXZAqR7DbfSZJ2XgsMeta } from "/var/www/tiodomin.com/pages/Products/[product].vue?macro=true";
import { default as indexVF3uLbd8X6ilp2DeCMZkdApttVJXqGjzodeM_453YIa_AMeta } from "/var/www/tiodomin.com/pages/admin/banners/index.vue?macro=true";
import { default as createwe6ugZ4KJMPncyZNI4rvuuDMO8QRWNf4P6lYb_4531FIMMeta } from "/var/www/tiodomin.com/pages/admin/brands/create.vue?macro=true";
import { default as create_4WBmN9f_45IcL9QCC48NUo_45pQpyLyo2zC5ft6LGckRFoMeta } from "/var/www/tiodomin.com/pages/admin/combos/create.vue?macro=true";
import { default as CreatepXZ5lBf1tr_9ukAvUaLBL7TUlSob2CuzHAvcVtHvi8YMeta } from "/var/www/tiodomin.com/pages/admin/offers/Create.vue?macro=true";
import { default as indexQQ_Plo_HEs72mRBTFnzLT3t0QsR0tZREL2HB4vVe_45aIMeta } from "/var/www/tiodomin.com/pages/admin/reviews/index.vue?macro=true";
import { default as ForgotPasswordE8Ws6S9FsDFRbAUU_mLlvnTfigOv25ZsVYz2NzErIFIMeta } from "/var/www/tiodomin.com/pages/Auth/ForgotPassword.vue?macro=true";
import { default as IndexTJTrVzTk5zAkInQkhL7Xr6tvjcoWLQzprGSbVC51rjAMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Index.vue?macro=true";
import { default as showD9YLgCmNm_45n4dsyedljI0BC7PZdXywHUKSCJyQH74vMMeta } from "/var/www/tiodomin.com/pages/orders/[order]/show.vue?macro=true";
import { default as index46ntphMetAKZGHJqvUaefC1mK_45dEmI9vRElRqWksuWkMeta } from "/var/www/tiodomin.com/pages/return-policy/index.vue?macro=true";
import { default as createFPxXDArcopz_45VJ3vb47_hEhMsqK7AMgnOV6Eu2_2qNcMeta } from "/var/www/tiodomin.com/pages/admin/banners/create.vue?macro=true";
import { default as indexWvp0jd8FMnmbPMGGTOeHxmA_LrYkyFm_459hVeWQ2VlGUMeta } from "/var/www/tiodomin.com/pages/admin/invoices/index.vue?macro=true";
import { default as indexbkC_45jdcPxCixLQ02DioUL60xJ3w6S9yP2GeenVd0Hm8Meta } from "/var/www/tiodomin.com/pages/admin/products/index.vue?macro=true";
import { default as ConfirmPasswordmPwFMVPAxx8HHu4jeMyOxGNhcd0pU5aqm9gorwlqPZgMeta } from "/var/www/tiodomin.com/pages/Auth/ConfirmPassword.vue?macro=true";
import { default as Create6QqqtS8ycF7z9XtBHd5y_H79BMhZv7wG16hNCr5ZCVEMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/Create.vue?macro=true";
import { default as editpkYT4hSmZiO0bbOOWFU2xB4TykNju5qR6GH2bp_JgbAMeta } from "/var/www/tiodomin.com/pages/Products/[slug]/edit.vue?macro=true";
import { default as SuccessPageo59bmjiaCKbhMuTzR54sJ7NfIF_8p4_45J8KuP9_5xq3YMeta } from "/var/www/tiodomin.com/pages/Products/SuccessPage.vue?macro=true";
import { default as indexqCU9M2GkTs1z7MQb7LWCNKQUQHYWGORJntGkwsQOaC8Meta } from "/var/www/tiodomin.com/pages/Profile/Orders/index.vue?macro=true";
import { default as indexMjA4C1P6I0vWrZU4O55Bh_uoibfo3XkvC0Q6_I491wUMeta } from "/var/www/tiodomin.com/pages/Profile/points/index.vue?macro=true";
import { default as Login8uWreNBOotdtEM5ayFU9HUhmrbkPbDDe5uYClVGjXxYMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Login.vue?macro=true";
import { default as SalesdnJg4MEmBLzSzsLPDQ0I4IwPsU_45Y3OPVkbgTxoBKbHEMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Sales.vue?macro=true";
import { default as _91id_938owmkf4L_PaZLvjnr_45u6qtazBYFDYR2DqvNHRK99vfEMeta } from "/var/www/tiodomin.com/pages/admin/categories/[id].vue?macro=true";
import { default as indexhdECFV4gCR1i_45MFBpFhI4cGoROqOmeYlwnFxFnfHtMAMeta } from "/var/www/tiodomin.com/pages/admin/criterias/index.vue?macro=true";
import { default as _91id_93TM6wFZbbmrg7NrFcKQjsQ7ZTsuNLXy9FQya9EHbX7MsMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/[id].vue?macro=true";
import { default as CreateDX1h0gohvLpJcr0esRIrb5jCaNhqw9EhSzMW7K1xVmgMeta } from "/var/www/tiodomin.com/pages/admin/invoices/Create.vue?macro=true";
import { default as Createlw6THcTpjnqedgR8wk9_Fu_45v023yVAiPI0nTr1u36XwMeta } from "/var/www/tiodomin.com/pages/admin/products/Create.vue?macro=true";
import { default as indexTYp_iBlyb5yZgx42dVlzTL_ceWdhgparKP9aGMedIPYMeta } from "/var/www/tiodomin.com/pages/shipment-policy/index.vue?macro=true";
import { default as indexiPdtGqZ3ALo_45h1wMfhDkMw7KfK53TEpDj_X8y4gIpsgMeta } from "/var/www/tiodomin.com/pages/warranty-policy/index.vue?macro=true";
import { default as VisitsyvZ9jyjzr1D9nQRYef1je7NIhNE4_gBOZQdPvEctxt8Meta } from "/var/www/tiodomin.com/pages/admin/analytics/Visits.vue?macro=true";
import { default as _91id_93D0grPGntx_454D4AiUHuJCKVRYAordkRUApY5Gr_uHx3EMeta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/[id].vue?macro=true";
import { default as index_45WjkztACnu0QI8ZvAdbRgxYz2QD_45EA6dGVm8U8ytPT8Meta } from "/var/www/tiodomin.com/pages/admin/categories/index.vue?macro=true";
import { default as indexDJio5TJ591_459nAlBtc5uQ1dGS6lbb7QrKPe6vtpvn1EMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/index.vue?macro=true";
import { default as indexyhW0g4ul_45344226ToF2espx4Scxd3JUKyNnPHzL8oRMMeta } from "/var/www/tiodomin.com/pages/admin/promotions/index.vue?macro=true";
import { default as verifyW_VM6x4M7bbNffTSHqIFJdf_djlpxhuZgw8GLgoX73cMeta } from "/var/www/tiodomin.com/pages/admin/promotors/verify.vue?macro=true";
import { default as indexL7Pg32u8tHmcypoz6_45_45a8sjrJLHWT6_45QvFwc1qK00WsMeta } from "/var/www/tiodomin.com/pages/terms-conditions/index.vue?macro=true";
import { default as index8Q5gi9EXqYu_452qV_2g_gnEH8GY9inpp7TMUD04PmCHwMeta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/index.vue?macro=true";
import { default as CreateXbXPyGkz8jZCThhYFj5eaCRxarbuXWs7uyYMzcEnAZwMeta } from "/var/www/tiodomin.com/pages/admin/categories/Create.vue?macro=true";
import { default as create719Fw8G2puwf4yR_hyeK2Vb98TkLIA9z7tadwBs1xEUMeta } from "/var/www/tiodomin.com/pages/admin/gift_Cards/create.vue?macro=true";
import { default as indexzZHuRB8aEbLFyme1COBRNjRgF10t6X08oUNIhi4RI8gMeta } from "/var/www/tiodomin.com/pages/admin/nomenclator/index.vue?macro=true";
import { default as createC0DlMRLzPDX5lrsNZbXIE1lsUc_45uwZYlFFH92Ir2OdUMeta } from "/var/www/tiodomin.com/pages/admin/promotions/create.vue?macro=true";
import { default as GeneralsYjLxH0uJuoOddZMrWBalFrWMoT4sN6WQJP_459DEe0xnAMeta } from "/var/www/tiodomin.com/pages/admin/settings/Generals.vue?macro=true";
import { default as _91id_93Zc5t7CyVNkZp2U_45rJ2ykPhns2qycuEqq3xnt7ClQ7BYMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/[id].vue?macro=true";
import { default as MostSold8K_8G8hW_45IKcqO7neMG0mmptbRMZJT_jNlg3kh4WJmQMeta } from "/var/www/tiodomin.com/pages/admin/analytics/MostSold.vue?macro=true";
import { default as createhQz1lyj0INO5Z7Nc2coPM9CL_45ACVeJehezZQn13h_45b4Meta } from "/var/www/tiodomin.com/pages/admin/blogs/posts/create.vue?macro=true";
import { default as indexZI1ob_45X5PX0MvIoFylDfTkoUwp483x892zGtCFaRILUMeta } from "/var/www/tiodomin.com/pages/admin/pointsSystem/index.vue?macro=true";
import { default as indexbc2g8m64p_rlTO151w5xAmGCb4mfW8Cf0Wih5ms6idwMeta } from "/var/www/tiodomin.com/pages/admin/reports/sale/index.vue?macro=true";
import { default as indextgypvSjN6Qx4lMm156ketwDnxpYJZxf97d_0Ib8EprQMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/index.vue?macro=true";
import { default as index_45N8FQ2Lr5ICLpYAijv_OWaYr4L5eWNDrHTEvbWERknoMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/index.vue?macro=true";
import { default as _91id_93kWY8eT8v3fq0m_xBVotcfimk2c5jvpgONBeA2gOEXiQMeta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/[id].vue?macro=true";
import { default as showLq70gxSmcEdQtmCJxw6zNmXuIoSlHt9XSNHQDT7_biAMeta } from "/var/www/tiodomin.com/pages/admin/orders/[order]/show.vue?macro=true";
import { default as _91id_93VvKt7EwdD3jesnEFWy1aNU7XOAb99fRbGPHno5F0VnkMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/[id].vue?macro=true";
import { default as showTvlC3zgTinhGlAGODtDMmpBJ18q8_E6TvTmkCH2YshgMeta } from "/var/www/tiodomin.com/pages/admin/promotors/[id]/show.vue?macro=true";
import { default as _91id_93jnsFE3SpTfxzXhb8t2A0eBflIlD9XJfHEDfB4bwVwxYMeta } from "/var/www/tiodomin.com/pages/admin/settings/coins/[id].vue?macro=true";
import { default as create_45UELcsOjspj6PmXxkbhgdZZw0n96Aw8orHYByR6Av1sMeta } from "/var/www/tiodomin.com/pages/admin/testimonials/create.vue?macro=true";
import { default as _91encoded_93_I74_j6VqqZFq3bTu46cv90WDEQKy_6MCQGbokRCmrkMeta } from "/var/www/tiodomin.com/pages/cart/share-cart/[encoded].vue?macro=true";
import { default as CreateBatchkYqtCyL9Nkjlgtdq_45jIRZ9okJ9YsO_45dhQr6EPHF99dsMeta } from "/var/www/tiodomin.com/pages/ExchangeRates/CreateBatch.vue?macro=true";
import { default as createrhDpP5sM8s4m3JWaPixHeAXoYlurBdf824PqLn_w8DgMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/create.vue?macro=true";
import { default as indexFHsYKUL_4565J_45IT7ZFpXN_45W6gX79Eq5qNaOduf8Dr_BQMeta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/index.vue?macro=true";
import { default as index_Yd9IMXGAMiXxNCykOBQJtr1fyMHagON3k5pY5g1fMYMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/index.vue?macro=true";
import { default as index0OqtKF6QAVWqH0a39uV5Py_451spGpesfXT3sLYLwSY7EMeta } from "/var/www/tiodomin.com/pages/Admin/PrintGiftCards/index.vue?macro=true";
import { default as editzquXj0T5u95ZGHr2NYNw5eHj_45P0WPoi0u1JTkE9qJKMMeta } from "/var/www/tiodomin.com/pages/admin/products/[slug]/edit.vue?macro=true";
import { default as promotors_wLqd9YEpRdfOh_t9tv2XbEhdBL8t4gkPYzG_45nbrdPgMeta } from "/var/www/tiodomin.com/pages/admin/promotions/promotors.vue?macro=true";
import { default as indexNa0y4AtKuLW_45Y9OxcYGbBcXn4fZaOVgwhgYJSEMehwYMeta } from "/var/www/tiodomin.com/pages/admin/reports/orders/index.vue?macro=true";
import { default as indexkqzHUEGX1Tdbe9jppr89WrDLwLitCDdXDu5kzK9y8sMMeta } from "/var/www/tiodomin.com/pages/admin/settings/coins/index.vue?macro=true";
import { default as _91id_93rsovXouOYHmcV5Y1P91SBQizAi_452EnaDpvYTq8e6vEUMeta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/[id].vue?macro=true";
import { default as createUyeQ8wPR7Zic_tDN1BNm4cUq5Lvc3X7fGxBiQ2lwC60Meta } from "/var/www/tiodomin.com/pages/admin/blogs/keywords/create.vue?macro=true";
import { default as createZ5vDKIL3sJuisBhk_45CqgAMsX4GAe4CiD6kUY77ZbILUMeta } from "/var/www/tiodomin.com/pages/admin/point_of_sales/create.vue?macro=true";
import { default as indexgWi9vV2CAjaT3qqskYG_Ga_8gfKaZKqHjvmpUZfqtUoMeta } from "/var/www/tiodomin.com/pages/admin/reports/catalog/index.vue?macro=true";
import { default as createNqQvmcFpzEHg_45ZDMyDSARGn_p7c_LfChiP0wrrsHiL4Meta } from "/var/www/tiodomin.com/pages/admin/settings/coins/create.vue?macro=true";
import { default as success_45pagezptPw8vWakqauFrFkhQ6XB547B_45_2EjnQF2w7pFLvg4Meta } from "/var/www/tiodomin.com/pages/orders/[order]/success-page.vue?macro=true";
import { default as index1Nrj6LbmNdo1ez2e3TeUyf0lfBkKFJa_45zneMWtJPNu8Meta } from "/var/www/tiodomin.com/pages/Profile/Beneficiaries/index.vue?macro=true";
import { default as indexQDvA3mVEHSkhntXeeNfvERtkfMxYnqNlPZKcITXtMXgMeta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/index.vue?macro=true";
import { default as CustomizationZ7nJQx1MopObQuQd6K8vitxvtDtZX_m0UxiT0GzeL2oMeta } from "/var/www/tiodomin.com/pages/admin/settings/Customization.vue?macro=true";
import { default as MiscayyyQyDb4oNVlJVbe_Ume4jL4QpF1e1mk_45yHDo_456TccMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Misc.vue?macro=true";
import { default as redirect_45pages77kW5W_KZzhYOUMYhY9tMMpy439eF_455CSyga9zpSGUMeta } from "/var/www/tiodomin.com/pages/orders/[order]/redirect-page.vue?macro=true";
import { default as analiticsH3_i3lpOH_45pQvMOoXBOR_45W6afQ_Ru3oi_45ryHi1Oex6cMeta } from "/var/www/tiodomin.com/pages/Profile/promotions/analitics.vue?macro=true";
import { default as create57I6n0_456tkhMfl7dx1pBgxrN_45jjSg42ijlZQYPHqRGMMeta } from "/var/www/tiodomin.com/pages/admin/blogs/categories/create.vue?macro=true";
import { default as indexB1IlNEvcgzGtWu1fSvAvQTOfkxfg5xlXfFInJ8Ktsh4Meta } from "/var/www/tiodomin.com/pages/admin/reports/inventory/index.vue?macro=true";
import { default as index_45bk5evv5bjP4Dlvh3n_45uNnunQv_45eppX9_BJZvQmjnHYMeta } from "/var/www/tiodomin.com/pages/admin/reports/movements/index.vue?macro=true";
import { default as Storew_45wgggS1R6nWBv6CXN_ZYtgPPUf6V3FlJGrOqA2hyA0Meta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Store.vue?macro=true";
import { default as _91InformationPage_93Q46c9FRsuptwdbQ3tUa78w7QEgJZ9sEbaAUU4_459wnXwMeta } from "/var/www/tiodomin.com/pages/information/[InformationPage].vue?macro=true";
import { default as drawer_request05TiHqUz_45aqZCdYdZJ7KAndGruNfUhnqbKeOY_oAJbsMeta } from "/var/www/tiodomin.com/pages/Admin/promotors/drawer_request.vue?macro=true";
import { default as indexjcwcw7iuGvYHuuiljYi8dq_45ABvWKT9kABVm_GLbMDaQMeta } from "/var/www/tiodomin.com/pages/admin/reports/unify_sale/index.vue?macro=true";
import { default as _91product_93O7aHRcjPipQDV27CYWrarKcUYNeNTUS_45mdbnDg00PycMeta } from "/var/www/tiodomin.com/pages/Products/Review/Read/[product].vue?macro=true";
import { default as indexdGf5HiilfhZC82MeftCnU7LymqcTQ_4fd_Sdqpwl1CAMeta } from "/var/www/tiodomin.com/pages/Admin/analytics/promotors/index.vue?macro=true";
import { default as indexDbivK0_45TrlWhgvvDNtkoZLxw8SIAnAtKpOxHy60u8o8Meta } from "/var/www/tiodomin.com/pages/admin/reports/soldProduct/index.vue?macro=true";
import { default as _91product_93H7DyfMSO_98cUbkaHZM2RraBsIDd571WMRE4dmQRvi8Meta } from "/var/www/tiodomin.com/pages/Products/Review/Write/[product].vue?macro=true";
import { default as ContactsDvAFQIrJF5j5xFP1NWcq3qqD6OYw6VGlxQnLMhXloSgMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Contacts.vue?macro=true";
import { default as PayFormsHZAE2BmzqldXZekt8QE1AZfZHs3Zyqie6HtgcmSJABsMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/PayForms.vue?macro=true";
import { default as Shipment3jymcXMfK_45ezJZ0ygkr90ALydwLGq4FZ6iOsNHvDqzIMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Shipment.vue?macro=true";
import { default as AccesseskEB_d3XxoByT1Gqk_MpSch_451Laxhn_gEprG3p4bhCmcMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/Accesses.vue?macro=true";
import { default as NewUsersNhCIuYxkKxJwoN7w_SWip55Q6LqRz0wnNFkc9ITh9vQMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/NewUsers.vue?macro=true";
import { default as EditAiTN7BQ7FIi0xwFjuhg8_45tbWJR2YxfbE7n_HUUV0Z2UMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/Edit.vue?macro=true";
import { default as TwiceTimea_45CY_45TErAiODU1QTOu1Gr7GiRwpSoIbMnUjtQpJgKq0Meta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/TwiceTime.vue?macro=true";
import { default as showBmTMDCiFBRYxWZnVkFt0YLtEZXhYm2RDLByZbybLGOYMeta } from "/var/www/tiodomin.com/pages/Admin/external_orders/[order]/show.vue?macro=true";
import { default as indexiVfLdVZ3JXQppYNFWvYP9T1R9ilQGTM5v9cJ_cmOldcMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/index.vue?macro=true";
import { default as indexEXxu80uF0JxipJhkeRxiEtIiBfiN_GrBrYi6qJobK_wMeta } from "/var/www/tiodomin.com/pages/admin/reports/salesaccounting/index.vue?macro=true";
import { default as createH_45vyhqYijIfo9QYyOMkX1AYPbg6MHvhw5RoMuTzn2yUMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/create.vue?macro=true";
import { default as LocalPickupi0WuUZbXoJlGGe2W8d3M5Pl6IzpBcOx01GeiGfbIb7MMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/LocalPickup.vue?macro=true";
import { default as PayFormItemyKD_CU2kMJy3JXUp4G2OJ_9tlDdn_7b2Np97zL2AN_45EMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/PayFormItem.vue?macro=true";
import { default as FrequentAsksX9e_NOaOKP7Ek4Puy9pp4cGh8uGv6K2_45doS_T9mW5D4Meta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/FrequentAsks.vue?macro=true";
import { default as ScheduleFormHYPDXCBYQPtLwv_45oSzUucepZjRRTy1dh6PMbUVTZ9esMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleForm.vue?macro=true";
import { default as ShoppingCardXSpqJcLHrWT1RRdL5tXrTjUtII7YkGoWD2zwQDZO5tQMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShoppingCard.vue?macro=true";
import { default as _91promotors_93h837Pt3Nxv_455gZ7G15WBhFqE5N7W_vVSJYnDX5xsOXkMeta } from "/var/www/tiodomin.com/pages/Admin/analytics/promotors/[promotors].vue?macro=true";
import { default as MiscellaneoussZtuKwekUGvwO_AIhV0GGb1ZmMpcTFQY1MeUrYvb2FgMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Miscellaneous.vue?macro=true";
import { default as NotificationsAevaaSPGa5KC6RRH9dBpw0y2ne0RW2EH8mbiKiEFXFMMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/Notifications.vue?macro=true";
import { default as ScheduleStorepmsKuxbSSIADPVYjkyby7Xr0N0GSRUQ1i6Pjy0ADUtgMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleStore.vue?macro=true";
import { default as _91promotor_93_45NlXVUHkzuUQi_45ywEcH1v8kBzEO93CmtCBVUJrAiy_45oMeta } from "/var/www/tiodomin.com/pages/admin/promotions/commisions/[promotor].vue?macro=true";
import { default as PerfilPromotorp_l_hEclFX1njojwCEOQYmsxacKAVOtARCH2069pMW8Meta } from "/var/www/tiodomin.com/pages/Admin/analytics/Partials/PerfilPromotor.vue?macro=true";
import { default as SalesBehaviour0OssDeQp9TMSyQtE4ov2SweikW22P5LH2sbgodoolWMMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/SalesBehaviour.vue?macro=true";
import { default as CreateBatchnRUEkOESzRX2A_45Ibl5sLSx21_T2HnGn0TVQHgkJYkMUMeta } from "/var/www/tiodomin.com/pages/admin/settings/exchangeRates/CreateBatch.vue?macro=true";
import { default as ShipmentProvinceHDhtggnW1vE_45nImyQwkAoVhTusonSAglXWIXH0jmR8wMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentProvince.vue?macro=true";
import { default as PagesMostVisitede_cdHK9n4IXxJylwJ2Jfck5hhB0cbk3iaP5mHT9xfEgMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/PagesMostVisited.vue?macro=true";
import { default as ProductsMostSoldti_458mmhBbVFb7Wvrtbb3IXQsjlADZaraVp0tGChEuMIMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostSold.vue?macro=true";
import { default as ProductsInventary5QT1yfbGS4N0C0KL2h9XE4_DURrCHWrWmMBoaE5vmqIMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ProductsInventary.vue?macro=true";
import { default as ShipmentUnitRange1SfvQZDt8Pj_GEkAb7Pfpz0pCy6iIBq6XPyvY4bv_VUMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentUnitRange.vue?macro=true";
import { default as InformationSectionr9GQg3xKanmTCCqVd0_BjC0L9dPU1BPGOpuMuCLBcOUMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/InformationSection.vue?macro=true";
import { default as ProductsMostVisitedHyvnd6AugsMp7DSJ8WUK3qeqUbmlJRCrs_VSQsYfMsIMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostVisited.vue?macro=true";
import { default as ProductsAggregatedCartOdCsStnHw8_45cGh8oOdgTcF5j6WveeLafkoQ70Km6xNkMeta } from "/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue?macro=true";
import { default as ShipmentSelectLocationsAE51LqGeKrzK4xPoSmMUrDY8Z2vYoL77av12KM4Zk9EMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue?macro=true";
import { default as RelatedProductStrategies_G_45K4NA_459xMPIJgTPHgAwnn5ifx_z4eEZZ3_RznokIEMeta } from "/var/www/tiodomin.com/pages/admin/settings/Partials/RelatedProductStrategies.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/var/www/tiodomin.com/pages/404.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/var/www/tiodomin.com/pages/info.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexGde6TRCslKgp7HMBmmFK3NvQc12F2pWCDwEB7gUOvxgMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/tiodomin.com/pages/[...slug].vue")
  },
  {
    name: "Auth-Login",
    path: "/Auth/Login",
    meta: {"middleware":["sanctum:guest","registered"]},
    component: () => import("/var/www/tiodomin.com/pages/Auth/Login.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/var/www/tiodomin.com/pages/blog/index.vue")
  },
  {
    name: "Cart",
    path: "/Cart",
    component: () => import("/var/www/tiodomin.com/pages/Cart/index.vue")
  },
  {
    name: "blog-blog",
    path: "/blog/:blog()",
    component: () => import("/var/www/tiodomin.com/pages/blog/[blog].vue")
  },
  {
    name: "store",
    path: "/store",
    meta: indexUqAkg1fYLS8XScs07cq01l5KcCDzxCc1dCQzQb8yotQMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/store/index.vue")
  },
  {
    name: "Offers",
    path: "/Offers",
    meta: indexzRt19rEySWiMy1rDMYjLnJT7ZmD8KzdE_plWkXNbizoMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Offers/index.vue")
  },
  {
    name: "Auth-Register",
    path: "/Auth/Register",
    component: () => import("/var/www/tiodomin.com/pages/Auth/Register.vue")
  },
  {
    name: "Profile",
    path: "/Profile",
    meta: { ...(indexT7HSezDPiJ8RjsmZEuPKbK2KaMRWh0KT67b9hx7MYp4Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/index.vue")
  },
  {
    name: "Products-Index",
    path: "/Products/Index",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/var/www/tiodomin.com/pages/Products/Index.vue")
  },
  {
    name: "Products-Create",
    path: "/Products/Create",
    meta: {"middleware":["sanctum:auth","check-create-product"]},
    component: () => import("/var/www/tiodomin.com/pages/Products/Create.vue")
  },
  {
    name: "admin-roles-id",
    path: "/admin/roles/:id()",
    meta: { ...(_91id_93wcYhWgD4ChJQGMpiwQTsoCdpS90MUZzVAH_Vm9RmLBcMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/[id].vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: { ...(_91id_936RGwGO3QU64w_619DpCFxEKegyyHC7_457f2y8jh1LS30Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/users/[id].vue")
  },
  {
    name: "Auth-VerifyEmail",
    path: "/Auth/VerifyEmail",
    component: () => import("/var/www/tiodomin.com/pages/Auth/VerifyEmail.vue")
  },
  {
    name: "Contact-Us",
    path: "/Contact-Us",
    component: () => import("/var/www/tiodomin.com/pages/Contact-Us/index.vue")
  },
  {
    name: "admin-brands-id",
    path: "/admin/brands/:id()",
    meta: { ...(_91id_93f1T382IGnwYAEosvcfjv87F0oBpYLcBAIfNXUrMfem4Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/[id].vue")
  },
  {
    name: "admin-combos-id",
    path: "/admin/combos/:id()",
    meta: { ...(_91id_93kntZo2JtxOn4HbI9_45WWjBoNvvoo_45hV0bdy_F6UvC6w4Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/[id].vue")
  },
  {
    name: "admin-offers-id",
    path: "/admin/offers/:id()",
    meta: { ...(_91id_933ytNar1YYFS9k5QQzIkMJ7oixxDiX_451ptJKFsiQWyyQMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/[id].vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: { ...(indexOrqGr5ejLYq_45aS_45hy9O6NCc7ng1TDa6ZWwPvpU_45gHUwMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(indexFs2H_bDMHBVxRB4AcKSKy_45q8tNkDUYhFcWohVLv8CiwMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/users/index.vue")
  },
  {
    name: "admin-banners-id",
    path: "/admin/banners/:id()",
    meta: { ...(_91id_93UVva_45JoDbHLbOkYuJF_RJcf0OuIxtz2AcaKvaHIbT6oMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/[id].vue")
  },
  {
    name: "admin-brands",
    path: "/admin/brands",
    meta: { ...(indexupZicUWiaEW5W_45uToxxt_45rN5R7uoXQUVMXWmFxsu1LQMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/index.vue")
  },
  {
    name: "admin-combos",
    path: "/admin/combos",
    meta: { ...(indexx3Rq9t0jaF4IvfEr8em8ijRwQkEYZho4eSaupiuuDpAMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/index.vue")
  },
  {
    name: "admin-offers",
    path: "/admin/offers",
    meta: { ...(indexF0XM7UzLffxHud0eXs_45vdo5jfD8SALwgHLumO1h6wgcMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/index.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: { ...(indexFB6K56NAbfy10k9uWxBOxQXeFOyHNv44WRmFXroU5kkMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/orders/index.vue")
  },
  {
    name: "admin-roles-Create",
    path: "/admin/roles/Create",
    meta: { ...(CreatepmHxsO_45lkUqbPTjnfjyXklX0mvmGN2DAl4jhdcgdQBIMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/roles/Create.vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    meta: { ...(createBttDJ0Q_45BUPIyu40N4Q9py8A0GWpr0pd4_CzugzbbbEMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/users/create.vue")
  },
  {
    name: "Auth-ResetPassword",
    path: "/Auth/ResetPassword",
    meta: ResetPasswordvV8JgYmHc3WvIapZKBrjO0MOBrwk2lSq8w0mhn94_45dAMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Auth/ResetPassword.vue"),
    children: [
  {
    name: "Auth-ResetPassword-token",
    path: ":token()",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ResetPassword/[token].vue")
  }
]
  },
  {
    name: "Distribution-Index",
    path: "/Distribution/Index",
    component: () => import("/var/www/tiodomin.com/pages/Distribution/Index.vue")
  },
  {
    name: "ExchangeRates-Edit",
    path: "/ExchangeRates/Edit",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Edit.vue")
  },
  {
    name: "Products-product",
    path: "/Products/:product()",
    meta: _91product_9339ZFB_45JUzLOjAzytQP6JxHVQZBBXZAqR7DbfSZJ2XgsMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Products/[product].vue")
  },
  {
    name: "admin-banners",
    path: "/admin/banners",
    meta: { ...(indexVF3uLbd8X6ilp2DeCMZkdApttVJXqGjzodeM_453YIa_AMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/index.vue")
  },
  {
    name: "admin-brands-create",
    path: "/admin/brands/create",
    meta: { ...(createwe6ugZ4KJMPncyZNI4rvuuDMO8QRWNf4P6lYb_4531FIMMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/brands/create.vue")
  },
  {
    name: "admin-combos-create",
    path: "/admin/combos/create",
    meta: { ...(create_4WBmN9f_45IcL9QCC48NUo_45pQpyLyo2zC5ft6LGckRFoMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/combos/create.vue")
  },
  {
    name: "admin-offers-Create",
    path: "/admin/offers/Create",
    meta: { ...(CreatepXZ5lBf1tr_9ukAvUaLBL7TUlSob2CuzHAvcVtHvi8YMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/offers/Create.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    meta: { ...(indexQQ_Plo_HEs72mRBTFnzLT3t0QsR0tZREL2HB4vVe_45aIMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reviews/index.vue")
  },
  {
    name: "Auth-ForgotPassword",
    path: "/Auth/ForgotPassword",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ForgotPassword.vue")
  },
  {
    name: "ExchangeRates-Index",
    path: "/ExchangeRates/Index",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Index.vue")
  },
  {
    name: "orders-order-show",
    path: "/orders/:order()/show",
    meta: { ...(showD9YLgCmNm_45n4dsyedljI0BC7PZdXywHUKSCJyQH74vMMeta || {}), ...{"middleware":["check-order-owner"]} },
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/show.vue")
  },
  {
    name: "return-policy",
    path: "/return-policy",
    component: () => import("/var/www/tiodomin.com/pages/return-policy/index.vue")
  },
  {
    name: "admin-banners-create",
    path: "/admin/banners/create",
    meta: { ...(createFPxXDArcopz_45VJ3vb47_hEhMsqK7AMgnOV6Eu2_2qNcMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/banners/create.vue")
  },
  {
    name: "admin-invoices",
    path: "/admin/invoices",
    meta: { ...(indexWvp0jd8FMnmbPMGGTOeHxmA_LrYkyFm_459hVeWQ2VlGUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/invoices/index.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: { ...(indexbkC_45jdcPxCixLQ02DioUL60xJ3w6S9yP2GeenVd0Hm8Meta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/products/index.vue")
  },
  {
    name: "Auth-ConfirmPassword",
    path: "/Auth/ConfirmPassword",
    component: () => import("/var/www/tiodomin.com/pages/Auth/ConfirmPassword.vue")
  },
  {
    name: "ExchangeRates-Create",
    path: "/ExchangeRates/Create",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/Create.vue")
  },
  {
    name: "Products-slug-edit",
    path: "/Products/:slug()/edit",
    component: () => import("/var/www/tiodomin.com/pages/Products/[slug]/edit.vue")
  },
  {
    name: "Products-SuccessPage",
    path: "/Products/SuccessPage",
    component: () => import("/var/www/tiodomin.com/pages/Products/SuccessPage.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    meta: { ...(indexqCU9M2GkTs1z7MQb7LWCNKQUQHYWGORJntGkwsQOaC8Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/Orders/index.vue")
  },
  {
    name: "Profile-points",
    path: "/Profile/points",
    meta: { ...(indexMjA4C1P6I0vWrZU4O55Bh_uoibfo3XkvC0Q6_I491wUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/points/index.vue")
  },
  {
    name: "admin-analytics-Login",
    path: "/admin/analytics/Login",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Login.vue")
  },
  {
    name: "admin-analytics-Sales",
    path: "/admin/analytics/Sales",
    meta: { ...(SalesdnJg4MEmBLzSzsLPDQ0I4IwPsU_45Y3OPVkbgTxoBKbHEMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Sales.vue")
  },
  {
    name: "admin-categories-id",
    path: "/admin/categories/:id()",
    meta: { ...(_91id_938owmkf4L_PaZLvjnr_45u6qtazBYFDYR2DqvNHRK99vfEMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/[id].vue")
  },
  {
    name: "admin-criterias",
    path: "/admin/criterias",
    meta: { ...(indexhdECFV4gCR1i_45MFBpFhI4cGoROqOmeYlwnFxFnfHtMAMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/criterias/index.vue")
  },
  {
    name: "admin-gift_Cards-id",
    path: "/admin/gift_Cards/:id()",
    meta: { ...(_91id_93TM6wFZbbmrg7NrFcKQjsQ7ZTsuNLXy9FQya9EHbX7MsMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/[id].vue")
  },
  {
    name: "admin-invoices-Create",
    path: "/admin/invoices/Create",
    meta: { ...(CreateDX1h0gohvLpJcr0esRIrb5jCaNhqw9EhSzMW7K1xVmgMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/invoices/Create.vue")
  },
  {
    name: "admin-products-Create",
    path: "/admin/products/Create",
    meta: { ...(Createlw6THcTpjnqedgR8wk9_Fu_45v023yVAiPI0nTr1u36XwMeta || {}), ...{"middleware":["sanctum:auth","check-create-product"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/products/Create.vue")
  },
  {
    name: "shipment-policy",
    path: "/shipment-policy",
    component: () => import("/var/www/tiodomin.com/pages/shipment-policy/index.vue")
  },
  {
    name: "warranty-policy",
    path: "/warranty-policy",
    component: () => import("/var/www/tiodomin.com/pages/warranty-policy/index.vue")
  },
  {
    name: "admin-analytics-Visits",
    path: "/admin/analytics/Visits",
    meta: { ...(VisitsyvZ9jyjzr1D9nQRYef1je7NIhNE4_gBOZQdPvEctxt8Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Visits.vue")
  },
  {
    name: "admin-blogs-posts-id",
    path: "/admin/blogs/posts/:id()",
    meta: { ...(_91id_93D0grPGntx_454D4AiUHuJCKVRYAordkRUApY5Gr_uHx3EMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/[id].vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: { ...(index_45WjkztACnu0QI8ZvAdbRgxYz2QD_45EA6dGVm8U8ytPT8Meta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/index.vue")
  },
  {
    name: "admin-gift_Cards",
    path: "/admin/gift_Cards",
    meta: { ...(indexDJio5TJ591_459nAlBtc5uQ1dGS6lbb7QrKPe6vtpvn1EMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/index.vue")
  },
  {
    name: "admin-promotions",
    path: "/admin/promotions",
    meta: { ...(indexyhW0g4ul_45344226ToF2espx4Scxd3JUKyNnPHzL8oRMMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/index.vue")
  },
  {
    name: "admin-promotors-verify",
    path: "/admin/promotors/verify",
    meta: { ...(verifyW_VM6x4M7bbNffTSHqIFJdf_djlpxhuZgw8GLgoX73cMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotors/verify.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/var/www/tiodomin.com/pages/terms-conditions/index.vue")
  },
  {
    name: "admin-blogs-posts",
    path: "/admin/blogs/posts",
    meta: { ...(index8Q5gi9EXqYu_452qV_2g_gnEH8GY9inpp7TMUD04PmCHwMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/index.vue")
  },
  {
    name: "admin-categories-Create",
    path: "/admin/categories/Create",
    meta: { ...(CreateXbXPyGkz8jZCThhYFj5eaCRxarbuXWs7uyYMzcEnAZwMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/categories/Create.vue")
  },
  {
    name: "admin-gift_Cards-create",
    path: "/admin/gift_Cards/create",
    meta: { ...(create719Fw8G2puwf4yR_hyeK2Vb98TkLIA9z7tadwBs1xEUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/gift_Cards/create.vue")
  },
  {
    name: "admin-nomenclator",
    path: "/admin/nomenclator",
    meta: { ...(indexzZHuRB8aEbLFyme1COBRNjRgF10t6X08oUNIhi4RI8gMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/nomenclator/index.vue")
  },
  {
    name: "admin-promotions-create",
    path: "/admin/promotions/create",
    meta: { ...(createC0DlMRLzPDX5lrsNZbXIE1lsUc_45uwZYlFFH92Ir2OdUMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/create.vue")
  },
  {
    name: "admin-settings-Generals",
    path: "/admin/settings/Generals",
    meta: { ...(GeneralsYjLxH0uJuoOddZMrWBalFrWMoT4sN6WQJP_459DEe0xnAMeta || {}), ...{"middleware":["sanctum:auth","check-notifications-settings"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Generals.vue")
  },
  {
    name: "admin-testimonials-id",
    path: "/admin/testimonials/:id()",
    meta: { ...(_91id_93Zc5t7CyVNkZp2U_45rJ2ykPhns2qycuEqq3xnt7ClQ7BYMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/[id].vue")
  },
  {
    name: "admin-analytics-MostSold",
    path: "/admin/analytics/MostSold",
    meta: { ...(MostSold8K_8G8hW_45IKcqO7neMG0mmptbRMZJT_jNlg3kh4WJmQMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/MostSold.vue")
  },
  {
    name: "admin-blogs-posts-create",
    path: "/admin/blogs/posts/create",
    meta: { ...(createhQz1lyj0INO5Z7Nc2coPM9CL_45ACVeJehezZQn13h_45b4Meta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/posts/create.vue")
  },
  {
    name: "admin-pointsSystem",
    path: "/admin/pointsSystem",
    meta: { ...(indexZI1ob_45X5PX0MvIoFylDfTkoUwp483x892zGtCFaRILUMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/pointsSystem/index.vue")
  },
  {
    name: "admin-reports-sale",
    path: "/admin/reports/sale",
    meta: { ...(indexbc2g8m64p_rlTO151w5xAmGCb4mfW8Cf0Wih5ms6idwMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/sale/index.vue")
  },
  {
    name: "admin-testimonials",
    path: "/admin/testimonials",
    meta: { ...(indextgypvSjN6Qx4lMm156ketwDnxpYJZxf97d_0Ib8EprQMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/index.vue")
  },
  {
    name: "Profile-promotions",
    path: "/Profile/promotions",
    meta: { ...(index_45N8FQ2Lr5ICLpYAijv_OWaYr4L5eWNDrHTEvbWERknoMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/index.vue")
  },
  {
    name: "admin-blogs-keywords-id",
    path: "/admin/blogs/keywords/:id()",
    meta: { ...(_91id_93kWY8eT8v3fq0m_xBVotcfimk2c5jvpgONBeA2gOEXiQMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/[id].vue")
  },
  {
    name: "admin-orders-order-show",
    path: "/admin/orders/:order()/show",
    meta: { ...(showLq70gxSmcEdQtmCJxw6zNmXuIoSlHt9XSNHQDT7_biAMeta || {}), ...{"middleware":["check-order-owner"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/orders/[order]/show.vue")
  },
  {
    name: "admin-point_of_sales-id",
    path: "/admin/point_of_sales/:id()",
    meta: { ...(_91id_93VvKt7EwdD3jesnEFWy1aNU7XOAb99fRbGPHno5F0VnkMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/[id].vue")
  },
  {
    name: "admin-promotors-id-show",
    path: "/admin/promotors/:id()/show",
    meta: { ...(showTvlC3zgTinhGlAGODtDMmpBJ18q8_E6TvTmkCH2YshgMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotors/[id]/show.vue")
  },
  {
    name: "admin-settings-coins-id",
    path: "/admin/settings/coins/:id()",
    meta: { ...(_91id_93jnsFE3SpTfxzXhb8t2A0eBflIlD9XJfHEDfB4bwVwxYMeta || {}), ...{"middleware":["sanctum:auth","check-edit-coin"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/[id].vue")
  },
  {
    name: "admin-testimonials-create",
    path: "/admin/testimonials/create",
    meta: { ...(create_45UELcsOjspj6PmXxkbhgdZZw0n96Aw8orHYByR6Av1sMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/testimonials/create.vue")
  },
  {
    name: "cart-share-cart-encoded",
    path: "/cart/share-cart/:encoded()",
    component: () => import("/var/www/tiodomin.com/pages/cart/share-cart/[encoded].vue")
  },
  {
    name: "ExchangeRates-CreateBatch",
    path: "/ExchangeRates/CreateBatch",
    component: () => import("/var/www/tiodomin.com/pages/ExchangeRates/CreateBatch.vue")
  },
  {
    name: "Profile-promotions-create",
    path: "/Profile/promotions/create",
    meta: { ...(createrhDpP5sM8s4m3JWaPixHeAXoYlurBdf824PqLn_w8DgMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/create.vue")
  },
  {
    name: "admin-blogs-keywords",
    path: "/admin/blogs/keywords",
    meta: { ...(indexFHsYKUL_4565J_45IT7ZFpXN_45W6gX79Eq5qNaOduf8Dr_BQMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/index.vue")
  },
  {
    name: "admin-point_of_sales",
    path: "/admin/point_of_sales",
    meta: { ...(index_Yd9IMXGAMiXxNCykOBQJtr1fyMHagON3k5pY5g1fMYMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/index.vue")
  },
  {
    name: "Admin-PrintGiftCards",
    path: "/Admin/PrintGiftCards",
    meta: { ...(index0OqtKF6QAVWqH0a39uV5Py_451spGpesfXT3sLYLwSY7EMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Admin/PrintGiftCards/index.vue")
  },
  {
    name: "admin-products-slug-edit",
    path: "/admin/products/:slug()/edit",
    meta: { ...(editzquXj0T5u95ZGHr2NYNw5eHj_45P0WPoi0u1JTkE9qJKMMeta || {}), ...{"middleware":["sanctum:auth","check-edit-product"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/products/[slug]/edit.vue")
  },
  {
    name: "admin-promotions-promotors",
    path: "/admin/promotions/promotors",
    meta: { ...(promotors_wLqd9YEpRdfOh_t9tv2XbEhdBL8t4gkPYzG_45nbrdPgMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/promotors.vue")
  },
  {
    name: "admin-reports-orders",
    path: "/admin/reports/orders",
    meta: { ...(indexNa0y4AtKuLW_45Y9OxcYGbBcXn4fZaOVgwhgYJSEMehwYMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/orders/index.vue")
  },
  {
    name: "admin-settings-coins",
    path: "/admin/settings/coins",
    meta: { ...(indexkqzHUEGX1Tdbe9jppr89WrDLwLitCDdXDu5kzK9y8sMMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/index.vue")
  },
  {
    name: "admin-blogs-categories-id",
    path: "/admin/blogs/categories/:id()",
    meta: { ...(_91id_93rsovXouOYHmcV5Y1P91SBQizAi_452EnaDpvYTq8e6vEUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/[id].vue")
  },
  {
    name: "admin-blogs-keywords-create",
    path: "/admin/blogs/keywords/create",
    meta: { ...(createUyeQ8wPR7Zic_tDN1BNm4cUq5Lvc3X7fGxBiQ2lwC60Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/keywords/create.vue")
  },
  {
    name: "admin-point_of_sales-create",
    path: "/admin/point_of_sales/create",
    meta: { ...(createZ5vDKIL3sJuisBhk_45CqgAMsX4GAe4CiD6kUY77ZbILUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/point_of_sales/create.vue")
  },
  {
    name: "admin-reports-catalog",
    path: "/admin/reports/catalog",
    meta: { ...(indexgWi9vV2CAjaT3qqskYG_Ga_8gfKaZKqHjvmpUZfqtUoMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/catalog/index.vue")
  },
  {
    name: "admin-settings-coins-create",
    path: "/admin/settings/coins/create",
    meta: { ...(createNqQvmcFpzEHg_45ZDMyDSARGn_p7c_LfChiP0wrrsHiL4Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/coins/create.vue")
  },
  {
    name: "orders-order-success-page",
    path: "/orders/:order()/success-page",
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/success-page.vue")
  },
  {
    name: "Profile-Beneficiaries",
    path: "/Profile/Beneficiaries",
    meta: {"middleware":"sanctum:auth"},
    component: () => import("/var/www/tiodomin.com/pages/Profile/Beneficiaries/index.vue")
  },
  {
    name: "admin-blogs-categories",
    path: "/admin/blogs/categories",
    meta: { ...(indexQDvA3mVEHSkhntXeeNfvERtkfMxYnqNlPZKcITXtMXgMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/index.vue")
  },
  {
    name: "admin-settings-Customization",
    path: "/admin/settings/Customization",
    meta: { ...(CustomizationZ7nJQx1MopObQuQd6K8vitxvtDtZX_m0UxiT0GzeL2oMeta || {}), ...{"middleware":["sanctum:auth","check-customization-settings"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Customization.vue")
  },
  {
    name: "admin-settings-Partials-Misc",
    path: "/admin/settings/Partials/Misc",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Misc.vue")
  },
  {
    name: "orders-order-redirect-page",
    path: "/orders/:order()/redirect-page",
    meta: redirect_45pages77kW5W_KZzhYOUMYhY9tMMpy439eF_455CSyga9zpSGUMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/orders/[order]/redirect-page.vue")
  },
  {
    name: "Profile-promotions-analitics",
    path: "/Profile/promotions/analitics",
    meta: { ...(analiticsH3_i3lpOH_45pQvMOoXBOR_45W6afQ_Ru3oi_45ryHi1Oex6cMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Profile/promotions/analitics.vue")
  },
  {
    name: "admin-blogs-categories-create",
    path: "/admin/blogs/categories/create",
    meta: { ...(create57I6n0_456tkhMfl7dx1pBgxrN_45jjSg42ijlZQYPHqRGMMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/blogs/categories/create.vue")
  },
  {
    name: "admin-reports-inventory",
    path: "/admin/reports/inventory",
    meta: { ...(indexB1IlNEvcgzGtWu1fSvAvQTOfkxfg5xlXfFInJ8Ktsh4Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/inventory/index.vue")
  },
  {
    name: "admin-reports-movements",
    path: "/admin/reports/movements",
    meta: { ...(index_45bk5evv5bjP4Dlvh3n_45uNnunQv_45eppX9_BJZvQmjnHYMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/movements/index.vue")
  },
  {
    name: "admin-settings-Partials-Store",
    path: "/admin/settings/Partials/Store",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Store.vue")
  },
  {
    name: "information-InformationPage",
    path: "/information/:InformationPage()",
    component: () => import("/var/www/tiodomin.com/pages/information/[InformationPage].vue")
  },
  {
    name: "Admin-promotors-drawer_request",
    path: "/Admin/promotors/drawer_request",
    meta: drawer_request05TiHqUz_45aqZCdYdZJ7KAndGruNfUhnqbKeOY_oAJbsMeta || {},
    component: () => import("/var/www/tiodomin.com/pages/Admin/promotors/drawer_request.vue")
  },
  {
    name: "admin-reports-unify_sale",
    path: "/admin/reports/unify_sale",
    meta: { ...(indexjcwcw7iuGvYHuuiljYi8dq_45ABvWKT9kABVm_GLbMDaQMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/unify_sale/index.vue")
  },
  {
    name: "Products-Review-Read-product",
    path: "/Products/Review/Read/:product()",
    component: () => import("/var/www/tiodomin.com/pages/Products/Review/Read/[product].vue")
  },
  {
    name: "Admin-analytics-promotors",
    path: "/Admin/analytics/promotors",
    meta: { ...(indexdGf5HiilfhZC82MeftCnU7LymqcTQ_4fd_Sdqpwl1CAMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/promotors/index.vue")
  },
  {
    name: "admin-reports-soldProduct",
    path: "/admin/reports/soldProduct",
    meta: { ...(indexDbivK0_45TrlWhgvvDNtkoZLxw8SIAnAtKpOxHy60u8o8Meta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/soldProduct/index.vue")
  },
  {
    name: "Products-Review-Write-product",
    path: "/Products/Review/Write/:product()",
    component: () => import("/var/www/tiodomin.com/pages/Products/Review/Write/[product].vue")
  },
  {
    name: "admin-settings-Partials-Contacts",
    path: "/admin/settings/Partials/Contacts",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Contacts.vue")
  },
  {
    name: "admin-settings-Partials-PayForms",
    path: "/admin/settings/Partials/PayForms",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/PayForms.vue")
  },
  {
    name: "admin-settings-Partials-Shipment",
    path: "/admin/settings/Partials/Shipment",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Shipment.vue")
  },
  {
    name: "admin-analytics-Partials-Accesses",
    path: "/admin/analytics/Partials/Accesses",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/Accesses.vue")
  },
  {
    name: "admin-analytics-Partials-NewUsers",
    path: "/admin/analytics/Partials/NewUsers",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/NewUsers.vue")
  },
  {
    name: "admin-settings-exchangeRates-Edit",
    path: "/admin/settings/exchangeRates/Edit",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/Edit.vue")
  },
  {
    name: "admin-settings-Partials-TwiceTime",
    path: "/admin/settings/Partials/TwiceTime",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/TwiceTime.vue")
  },
  {
    name: "Admin-external_orders-order-show",
    path: "/Admin/external_orders/:order()/show",
    meta: { ...(showBmTMDCiFBRYxWZnVkFt0YLtEZXhYm2RDLByZbybLGOYMeta || {}), ...{"middleware":["check-order-external-owner"]} },
    component: () => import("/var/www/tiodomin.com/pages/Admin/external_orders/[order]/show.vue")
  },
  {
    name: "admin-settings-exchangeRates",
    path: "/admin/settings/exchangeRates",
    meta: { ...(indexiVfLdVZ3JXQppYNFWvYP9T1R9ilQGTM5v9cJ_cmOldcMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/index.vue")
  },
  {
    name: "admin-reports-salesaccounting",
    path: "/admin/reports/salesaccounting",
    meta: { ...(indexEXxu80uF0JxipJhkeRxiEtIiBfiN_GrBrYi6qJobK_wMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/reports/salesaccounting/index.vue")
  },
  {
    name: "admin-settings-exchangeRates-create",
    path: "/admin/settings/exchangeRates/create",
    meta: { ...(createH_45vyhqYijIfo9QYyOMkX1AYPbg6MHvhw5RoMuTzn2yUMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/create.vue")
  },
  {
    name: "admin-settings-Partials-LocalPickup",
    path: "/admin/settings/Partials/LocalPickup",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/LocalPickup.vue")
  },
  {
    name: "admin-settings-Partials-PayFormItem",
    path: "/admin/settings/Partials/PayFormItem",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/PayFormItem.vue")
  },
  {
    name: "admin-settings-Partials-FrequentAsks",
    path: "/admin/settings/Partials/FrequentAsks",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/FrequentAsks.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleForm",
    path: "/admin/settings/Partials/ScheduleForm",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleForm.vue")
  },
  {
    name: "admin-settings-Partials-ShoppingCard",
    path: "/admin/settings/Partials/ShoppingCard",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShoppingCard.vue")
  },
  {
    name: "Admin-analytics-promotors-promotors",
    path: "/Admin/analytics/promotors/:promotors()",
    meta: { ...(_91promotors_93h837Pt3Nxv_455gZ7G15WBhFqE5N7W_vVSJYnDX5xsOXkMeta || {}), ...{"middleware":"sanctum:auth"} },
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/promotors/[promotors].vue")
  },
  {
    name: "admin-settings-Partials-Miscellaneous",
    path: "/admin/settings/Partials/Miscellaneous",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Miscellaneous.vue")
  },
  {
    name: "admin-settings-Partials-Notifications",
    path: "/admin/settings/Partials/Notifications",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/Notifications.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleStore",
    path: "/admin/settings/Partials/ScheduleStore",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ScheduleStore.vue")
  },
  {
    name: "admin-promotions-commisions-promotor",
    path: "/admin/promotions/commisions/:promotor()",
    meta: { ...(_91promotor_93_45NlXVUHkzuUQi_45ywEcH1v8kBzEO93CmtCBVUJrAiy_45oMeta || {}), ...{"middleware":["sanctum:auth"]} },
    component: () => import("/var/www/tiodomin.com/pages/admin/promotions/commisions/[promotor].vue")
  },
  {
    name: "Admin-analytics-Partials-PerfilPromotor",
    path: "/Admin/analytics/Partials/PerfilPromotor",
    component: () => import("/var/www/tiodomin.com/pages/Admin/analytics/Partials/PerfilPromotor.vue")
  },
  {
    name: "admin-analytics-Partials-SalesBehaviour",
    path: "/admin/analytics/Partials/SalesBehaviour",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/SalesBehaviour.vue")
  },
  {
    name: "admin-settings-exchangeRates-CreateBatch",
    path: "/admin/settings/exchangeRates/CreateBatch",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/exchangeRates/CreateBatch.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentProvince",
    path: "/admin/settings/Partials/ShipmentProvince",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentProvince.vue")
  },
  {
    name: "admin-analytics-Partials-PagesMostVisited",
    path: "/admin/analytics/Partials/PagesMostVisited",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/PagesMostVisited.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostSold",
    path: "/admin/analytics/Partials/ProductsMostSold",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostSold.vue")
  },
  {
    name: "admin-settings-Partials-ProductsInventary",
    path: "/admin/settings/Partials/ProductsInventary",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ProductsInventary.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentUnitRange",
    path: "/admin/settings/Partials/ShipmentUnitRange",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentUnitRange.vue")
  },
  {
    name: "admin-settings-Partials-InformationSection",
    path: "/admin/settings/Partials/InformationSection",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/InformationSection.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostVisited",
    path: "/admin/analytics/Partials/ProductsMostVisited",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsMostVisited.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsAggregatedCart",
    path: "/admin/analytics/Partials/ProductsAggregatedCart",
    component: () => import("/var/www/tiodomin.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentSelectLocations",
    path: "/admin/settings/Partials/ShipmentSelectLocations",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue")
  },
  {
    name: "admin-settings-Partials-RelatedProductStrategies",
    path: "/admin/settings/Partials/RelatedProductStrategies",
    component: () => import("/var/www/tiodomin.com/pages/admin/settings/Partials/RelatedProductStrategies.vue")
  }
]